import React, { useEffect, useState } from 'react';
import { Pie } from 'react-chartjs-2';
import { useDispatch, useSelector } from 'react-redux';
import { getAllTaskDetailsByloginId } from '../../Redux/Task/Action';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { getLeaveBalanceList } from "../../Redux/Leave/Action";


ChartJS.register(ArcElement, Tooltip, Legend, ChartDataLabels);

const EmployeeDash = () => {

  const dispatch = useDispatch();
  const { allTaskDetails } = useSelector((store) => store.task);
  const { leavebalancelist } = useSelector((store) => store.leave);
  const token = localStorage.getItem("token");
  const loginId = localStorage.getItem("loginId");

  const [statusCounts, setStatusCounts] = useState({});

  const loadDashBoard = (token, loginId) => {
    dispatch(getLeaveBalanceList(token, loginId, 'Apply'));
    dispatch(getAllTaskDetailsByloginId(loginId, token));
  }

  useEffect(() => {
    loadDashBoard(token, loginId);
  }, [token, loginId]);

  useEffect(() => {
    if (allTaskDetails?.taskMaster?.length > 0) {
      const counts = allTaskDetails.taskMaster.reduce((acc, task) => {
        const status = task.status || "Unknown";
        acc[status] = (acc[status] || 0) + 1;
        return acc;
      }, {});
      setStatusCounts(counts);
    } else {
      setStatusCounts({});
    }
  }, [allTaskDetails]);


  const STATUS_ORDER = [
    "To Do",
    "In Progress",
    "In Testing",
    "Rejected",
    "Reopened",
    "Done",
    "Unknown",
  ];

  const STATUS_COLOR_MAP = {
    "To Do": "#42a5f5",
    "In Progress": "#aebb66ff",
    "In Testing": "#ffca28",
    "Rejected": "#ef5350",
    "Reopened": "#ab47bc",
    "Done": "#2a962fff",
    "Unknown": "#8d6e63",
  };

  //  Build labels, values, and colors arrays in the fixed order
  const labels = [];
  const dataValues = [];
  const colors = [];

  STATUS_ORDER.forEach((statusKey) => {
    const count = statusCounts[statusKey] || 0;
    if (count > 0) {
      labels.push(statusKey);
      dataValues.push(count);
      colors.push(STATUS_COLOR_MAP[statusKey] || "#8d6e63");
    }
  });

  //  Prepare your chart dataset using those arrays
  const taskDataforChart = {
    labels,
    datasets: [
      {
        label: "Task Status Count",
        data: dataValues,
        backgroundColor: colors,
        borderColor: "#ffffff",
        borderWidth: 2,
      },
    ],
  };

  // Chart options (same as before)
  const dashOptionsforChart = {
    responsive: true,
    plugins: {
      legend: {
        position: "bottom",
        labels: {
          color: "#333",
          boxWidth: 10, // default is 40 → make smaller
          boxHeight: 10,
          padding: 12,

          font: { size: 13, weight: "500" },
        },
      },
      datalabels: {
        color: "#fff",
        font: { weight: "bold", size: 14 },
        formatter: (value) => value,
      },
      tooltip: {
        callbacks: {
          label: (context) => `${context.label}: ${context.formattedValue}`,
        },
      },
    },
  };

  const isDatePast = (dateStr) => {
    if (!dateStr) return false;
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const [day, month, year] = dateStr.split("-");
    const endDate = new Date(year, month - 1, day);
    endDate.setHours(0, 0, 0, 0);
    return endDate < today;
  };

  return (
    <div>

      <div className='row'>
        <div className="col-md-12 mb-4">

          <div className="row">
            {/* Chart 1 - Pie Chart (col 3) */}
            <div className="col-md-3 mb-4">
              <div className="card shadow-sm rounded-4" style={{ minHeight: "409px" }}>
                <div className="card-body d-flex flex-column justify-content-center align-items-center">
                  <h6 className="text-center mb-3 w-100 fw-bold">Task Status Overview</h6>
                  <div
                    style={{
                      width: "111%",
                      height: 280,
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    {labels.length > 0 ? (
                      <Pie data={taskDataforChart} options={dashOptionsforChart} />
                    ) : (
                      <p className="text-center text-muted">No data available</p>
                    )}
                  </div>
                </div>
              </div>
            </div>



            <div className="col-md-6 mb-4">
              <div className="card shadow-sm rounded-4" style={{ minHeight: "409px" }}>
                <div className="card-body d-flex flex-column">
                  <h6 className="text-center mb-1 fw-bold">Task Details</h6>

                  {/* Status color legend */}
                  <div
                    style={{
                      display: 'flex',
                      flexWrap: 'wrap',
                      alignItems: 'center',
                      gap: '12px',
                      marginTop: '10px',
                    }}
                  >
                    {Object.entries(STATUS_COLOR_MAP)
                      .filter(([status]) => status !== "Unknown" && status !== "Done")
                      .map(([status, color]) => (
                        <div key={status} style={{ display: 'flex', alignItems: 'center' }}>
                          <div
                            style={{
                              width: '14px',
                              height: '14px',
                              backgroundColor: color,
                              borderRadius: '3px',
                              marginRight: '6px',
                              border: '1px solid #ccc',
                            }}
                          ></div>
                          <span style={{ fontWeight: 500, fontSize: '0.9rem' }}>{status}</span>
                        </div>
                      ))}
                  </div>

                  {/* Task table */}
                  <div
                    style={{
                      flex: 1,
                      overflowY: "auto",
                      maxHeight: "300px",
                    }}
                  >
                    {allTaskDetails?.taskMaster && allTaskDetails.taskMaster.length > 0 ? (
                      <table className="table table-sm table-hover align-middle mb-0">
                        <thead className="table-light sticky-header">
                          <tr>
                            <th>Task No</th>
                            <th>Title</th>
                            <th>PDC</th>
                          </tr>
                        </thead>
                        <tbody>
                          {allTaskDetails.taskMaster
                            .filter(task => task.status !== "Done")
                            .map((task, index) => (
                              <tr key={task.id || index}>
                                <td
                                  style={{
                                    fontWeight: '500',
                                    color: STATUS_COLOR_MAP[task.status] || STATUS_COLOR_MAP["Unknown"],
                                  }}
                                >
                                  {task.taskNo || '-'}
                                </td>
                                <td className="text-start">{task.title || '-'}</td>
                                <td
                                  className={`fw-medium ${isDatePast(task.endDate) ? 'text-danger' : ''}`}
                                >
                                  {task.endDate || '-'}
                                </td>
                              </tr>
                            ))}
                        </tbody>
                      </table>
                    ) : (
                      <p className="text-center text-muted mt-3">No tasks available</p>
                    )}
                  </div>
                </div>
              </div>
            </div>



            {/* Chart 3 - (col 3) */}
            <div className="col-md-3 mb-4">
              <div className="card shadow-sm rounded-4" style={{ minHeight: "409px" }}>
                <div className="card-body d-flex flex-column">
                  <h6 className="text-center mb-3 fw-bold">Leave Data</h6>

                  <div
                    style={{
                      width: "100%",
                      height: 300,
                      overflowY: "auto",
                      padding: "0 10px",
                    }}
                  >
                    {Array.isArray(leavebalancelist) && leavebalancelist.length > 0 ? (
                      leavebalancelist.map((leave, index) => (
                        <div
                          key={leave?.leaveBalanceId ?? "-"}
                          style={{
                            marginBottom: "12px",
                            padding: "8px",
                            borderRadius: "8px",
                            background: "#f1f5f9",
                            boxShadow: "inset 0 0 4px rgba(0,0,0,0.05)",
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              marginBottom: "4px",
                              alignItems: "center",
                            }}
                          >
                            <span
                              style={{
                                fontWeight: "600",
                                color: "#0a6ebd",
                                background: "#e0f0ff",
                                padding: "2px 6px",
                                borderRadius: "4px",
                                fontSize: "0.85rem",
                              }}
                            >
                              {leave?.leaveCode ?? "-"}
                            </span>
                            <span style={{ fontSize: "0.85rem", color: "#333" }}>
                              Total Days: {(leave?.leaveDays ?? 0) + (leave?.appliedDays ?? 0)}
                            </span>
                          </div>

                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              fontSize: "0.85rem",
                              color: "#555",
                            }}
                          >
                            <span>Applied: {leave?.appliedDays ?? 0}</span>
                            <span>Available: {leave?.leaveDays ?? 0}</span>
                          </div>
                        </div>
                      ))
                    ) : (
                      <p className="text-center text-muted">No leave data available</p>
                    )}
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  );
};

export default EmployeeDash;